import Vue from "vue";
import { Component } from "vue-property-decorator";
import { validations, validationMessages } from "./validations";
import * as icons from "@/components/icons";
import {
    IBrand,
} from "@/models";
import { Validation } from "vuelidate";

@Component({
    name: "brands",
    validations,
    components: {
        "add-icon": icons.AddIcon,
        "edit-icon": icons.EditIcon,
        "save-icon": icons.SaveIcon,
        "delete-icon": icons.DeleteIcon,
    },
})

export default class Brands extends Vue {
    public loadPromises: Array<Promise<any>>;
    public brandId: number;
    public brandSearch: string;
    public brandName: string;
    public editingBrandName: string;
    public editingBrandId: number;

    constructor() {
        super();

        this.loadPromises = [];
        this.brandId = null;
        this.brandSearch = "";
        this.brandName = "";
        this.editingBrandName = "";
        this.editingBrandId = 0;

        if (!this.$store.state.request.isReferenceDataLoaded) {
            this.loadPromises.push(this.$store.dispatch("request/fetchReferenceData"));
        }
    }

    public async addBrand(): Promise<void> {
        if (this.validateBeforeSave(this.$v.brandName)) {
            await this.$store.dispatch("request/addBrand", {
                Name: this.brandName,
            });

            this.brandName = "";
            this.$v.brandName.$reset();
        }
    }

    public get validationMessages(): { [key: string]: string } {
        return validationMessages;
    }

    public async editBrand(brand: IBrand): Promise<void> {
        this.editingBrandId = brand?.brandId ?? 0;
        this.editingBrandName = brand?.name ?? "";
    }

    public async saveEditBrand(brand: IBrand): Promise<void> {
        if (this.validateBeforeSave(this.$v.editingBrandName)) {
            this.editingBrandId = 0;
            brand.name = this.editingBrandName;
            await this.$store.dispatch("request/saveEditBrand", brand);
            this.editingBrandName = "";
            this.$v.editingBrandName.$reset();
        }
    }

    public async deleteBrand(brandId: number): Promise<void> {
        await this.$store.dispatch("request/deleteBrand", brandId);
    }

    public get brands(): IBrand[] {
        return this.$store.getters["request/getFilteredBrands"](this.brandSearch);
    }

    public validateBeforeSave(rules: Validation): boolean {
        rules.$touch();
        return !rules.$invalid;
    }
}

